var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleTool(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_2205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8H22.5V5H19.5V6.006L5.5 2.461V1H2.5V4H3.5V10H1.5V18H3.5V20H2.5V23H5.5V22H19.5V23H22.5V20H21.5V18H23.5V10H21.5V8ZM20.5 6H21.5V7H20.5V6ZM3.5 2H4.5V3H3.5V2ZM4.5 4H5.5V3.498L19.5 7.043V8H20.5V10H4.5V4ZM4.5 22H3.5V21H4.5V22ZM21.5 22H20.5V21H21.5V22ZM20.5 20H19.5V21H5.5V20H4.5V18H20.5V20ZM22.5 11V17H21.5V14H20.5V17H19.5V15H18.5V17H17.5V12H16.5V17H15.5V15H14.5V17H13.5V14H12.5V17H11.5V15H10.5V17H9.5V12H8.5V17H7.5V15H6.5V17H5.5V14H4.5V17H2.5V11H22.5Z",
    fill: "#717784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_2205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleTool);
export default __webpack_public_path__ + "static/media/angle-tool.8b00cfab432ee1a16e2de6e127f1c0c3.svg";
export { ForwardRef as ReactComponent };